import React from 'react';

import logo from '../batempalmalogo.png';
import './Header.css';

function Header({ round, boxesLeft, estimate, onOffersClick, onProgressClick }) {
  return (
    <div className="bp-header">
      <div className="bp-header-progress" style={{ cursor: 'pointer' }} onClick={onProgressClick}>
        <div className="bp-header-progress-col">
          <div className="bp-round-value">{round} / {boxesLeft}</div>
        </div>
      </div>
      <img src={logo} alt="Batem Palma Logo" className="bp-logo" />
      <div className="bp-header-progress">
        <div className="bp-header-progress-col">
          <div className="bp-round-value" style={{ cursor: 'pointer' }} onClick={onOffersClick}>{estimate || '-'}</div>
        </div>
      </div>
    </div>
  );
}

export default Header;
